<template>
  <v-container style="min-height: 2400px;">
  
<v-row>
    <v-col cols="12" md="8">
   


    <section class="togo-section mt-6">
      <h3 class="text-green">Für Zahnärzte kostenlos</h3>
    <h2>
      Jetzt WaizmannTabellen
      <span class="text-green">2025</span> anfordern
    </h2>


      <div
        v-for="product in filteredTogoProducts"
        :key="product.id"
        class="togo-row my-4"
      >
        <div
          class="togo-row__info product-selection"
          role="button"
          tabindex="0"
          @click="toggleTogoSelection(product)"
        >
          <img :src="product.image" :alt="product.alt" class="togo-row__picto" />
          <div>
            <div class="togo-row__headline">
              <h3 class="togo-row__title">
                {{ product.title }}
                <sup v-if="product.badge" class="text-green">{{ product.badge }}</sup>
              </h3>
              <p class="togo-row__text">
                {{ product.description }}
              </p>
            </div>
            <v-switch
              color="green"
              inset
              hide-details
              density="compact"
              class="mt-2"
              :label="product.switchLabel"
              :model-value="isProductSelected(product.tableProduct)"
              @click.stop
              @update:modelValue="() => toggleTogoSelection(product)"
            ></v-switch>
            <p
              v-if="isProductSelected(product.tableProduct)"
              class="text-caption mt-1 text-green"
            >
              Hinweis: Zum Anfordern bitte unten auf „Jetzt kostenlos anfordern“ klicken.
            </p>
          </div>
        </div>
        <div class="togo-row__stands">
          <p
            v-if="needsStandSelection(product.id, product.tableProduct)"
            class="stands-label text-green"
          >
            Wählen Sie jetzt Ihren Aufsteller
          </p>
          <div class="stand-buttons">
            <v-btn
              variant="outlined"
              size="small"
              :disabled="!isProductSelected(product.tableProduct)"
              :color="standSelections[product.id].premium ? 'green' : 'primary'"
              :class="['stand-btn', { 'stand-btn--active': standSelections[product.id].premium }]"
              @click="handleStandClick(product.id, 'premium')"
            >
              Premium
            </v-btn>
            <v-btn
              variant="outlined"
              size="small"
              :disabled="!isProductSelected(product.tableProduct)"
              :color="standSelections[product.id].normal ? 'green' : 'primary'"
              :class="['stand-btn', { 'stand-btn--active': standSelections[product.id].normal }]"
              @click="handleStandClick(product.id, 'normal')"
            >
              Standard
            </v-btn>
          </div>
          <small class="stand-hint">
            Premium: Acrylglas für Wartezimmer · Standard: kompakter Aufsteller für den Empfang. Sie dürfen gerne beide Aufsteller <b>kostenlos</b> anfordern.
          </small>
          <div class="stand-visuals mt-3">
            <div
              v-for="option in standVisualOrder"
              :key="`${product.id}-${option}`"
              :class="[
                'stand-visuals__item',
                {
                  'stand-visuals__item--active': standSelections[product.id][option],
                  'stand-visuals__item--disabled': !isProductSelected(product.tableProduct),
                },
              ]"
              @click="isProductSelected(product.tableProduct) && handleStandClick(product.id, option)"
            >
              <img
                :src="standVisuals[option].image"
                :alt="standVisuals[option].title"
                class="stand-visuals__image"
              />
              <div class="stand-visuals__content">
                <p class="stand-visuals__title">{{ standVisuals[option].title }}</p>
                <p class="stand-visuals__text">{{ standVisuals[option].text }}</p>
                <v-chip
                  v-if="standSelections[product.id][option]"
                  color="green"
                  size="small"
                  density="comfortable"
                  variant="flat"
                  class="mt-1"
                >
                  Ausgewählt
                </v-chip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="togo-section my-8">
      <div
        class="edition-row my-0 product-selection"
        role="button"
        tabindex="0"
        @click="toggleGesamtausgabe"
        @keydown.enter.prevent="toggleGesamtausgabe"
      >
        <div class="edition-row__info">
          <img
            :src="gesamtausgabeImage"
            alt="WaizmannTabelle Gesamtausgabe"
            class="edition-row__image"
          />
          <div class="edition-row__content">
            <h3 class="edition-row__title">
              WaizmannTabelle Gesamtausgabe {{ baseStore.thisYear }}
            </h3>
            <p class="edition-row__text">
              Alle getesteten Zahnzusatzversicherungen inklusive PZR-Flatrate-Vergleich, Wechselanleitung
              und Tipps für abrechnungsstarke Tarife. Ideal für den Lesebereich im Wartezimmer.
            </p>
            <v-switch
              color="green"
              inset
              hide-details
              density="compact"
              class="mt-3"
              :model-value="isProductSelected(PRODUCT_KEYS.GESAMT)"
              @click.stop
              @update:modelValue="() => addOderEntferneProdukt(PRODUCT_KEYS.GESAMT, 'tabelle')"
              label="Gesamtausgabe kostenlos anfordern"
            ></v-switch>
            <p
              v-if="isProductSelected(PRODUCT_KEYS.GESAMT)"
              class="text-caption mt-1 text-green"
            >
              Hinweis: Zum Anfordern bitte unten auf „Jetzt kostenlos anfordern“ klicken.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="togo-section mt-8">
    <v-row>
      <v-col cols="12" md="12" class="my-0 py-0">
        <div v-if="!showFormAdress" class="caption pa-4 mb-4 address-request-card">
         <h3><a  @click="show_comment = !show_comment"
            >Sie benötigen eine größere Menge?</a
          ></h3>
          Klicken
          <a @click="show_comment = !show_comment">Sie jetzt hier</a> und
          schreiben Sie uns, wieviel Sie genau benötigen.
         
        <span v-if="show_comment">
          <br /><br />
          <v-textarea
            label="Welche Menge benötigen Sie?"
            style="width: 400px;" bg-color="white"
            v-model="bestellung.bestell_comment"
          ></v-textarea>
   
        </span>
        </div>
      
        <v-alert
          v-if="bestellung.bestell_produkt_text == ''"
          color="orange-darken-2"
          variant="tonal"
          border="start"
          class="hint-alert mb-4"
        >
          <strong>Hinweis:</strong> Bitte wählen Sie die gewünschten Tabellen, um mit der Bestellung fortzufahren.
        </v-alert>
        <div v-if="showSuccessUpdate" class="my-4">
          <h3 class="text-green">Ihre Adresse wurde aktualisiert - jetzt können Sie die WaizmannTabellen anfordern</h3>
        </div>
        <div class="my-4"  v-if="bestellung.bestell_produkt_text != '' && showFormAdress">
          <v-row >
            <v-col cols="12"><h3>Bitte ergänzen Sie noch Ihre Adresse</h3></v-col>
          </v-row>
           
  
          <v-row>
            <v-col cols="12" md="9">
            
              <v-text-field
                v-model="updateuserData.user_strasse"
                label="Strasse"
                type="char"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="updateuserData.user_hsnr"
                label="Hausnummer"
                type="char"
                required
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="updateuserData.user_plz"
                label="PLZ"
                type="char"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="updateuserData.user_ort"
                label="Ort"
                type="char"
                required
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="9">
              <v-btn color="primary" @click="updateUserAddress">
                jetzt Adresse aktualisieren
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
           
            </v-col>
          </v-row>
        </div>
        <h3 class="text-red my-4" v-if="userData && (userData.user_strasse == '' || userData.user_plz == '' || userData.user_ort == '')">Bitte speichern Sie noch Ihre Adresse <br><a @click="showUserUpdate = !showUserUpdate">hier klicken um Adresse zu speichern</a></h3>        

        <div
          v-if="bestellung.bestell_produkt_text != ''"
          class="selected-products-card mb-4"
        >
          <p class="eyebrow eyebrow--normal mb-1">Ihre gewählten WaizmannTabellen</p>
      
          <div class="selected-products-card__chips">
            <v-chip
              v-for="produkt in getProduktListe()"
              :key="produkt"
              class="selected-chip"
              color="green"
              variant="tonal"
              size="small"
            >
              {{ produkt }}
            </v-chip>
          </div>
        </div>

        <v-btn
          v-if="bestellung.bestell_produkt_text != '' && !showFormAdress"
          color="primary"
          style="height: 48px; font-size: 16px"
          elevated
          tile
          @click="startNeueBestellung"
          type="submit"
          class="button_caps"
          tonal
        >
          <span class="white--text"   v-if="baseStore.isDesktop">

         
            <v-icon style="font-size: 28px">play_arrow</v-icon> jetzt<span
              >&nbsp;kostenlos neue&nbsp;</span
            >WaizmannTabellen anfordern
          </span>
          <span class="white--text"   v-if="!baseStore.isDesktop">
            <v-icon style="font-size: 28px">play_arrow</v-icon> jetzt kostenlos anfordern
          </span>
        </v-btn>
        <div
          class="py-4 mt-4 address-check-card"
          v-if="bestellung.bestell_produkt_text != '' && !showFormAdress"
        >
          <h2 class="text-green">Ist Ihre Adresse noch korrekt?</h2>
          <ul>
            <li>{{ userData.user_name }}</li>
            <li v-if="userData.user_strasse != ''">{{ userData.user_strasse }} {{ userData.user_hsnr }}</li>
            <li v-else><b>Bitte speichern Sie noch Ihre Strasse und Hausnummer</b></li>
            <li v-if="userData.user_ort != ''">{{ userData.user_plz }} {{ userData.user_ort }}</li>
            <li v-else><b>Bitte speichern Sie noch Ihre PLZ und Ort</b></li>
         <li>
              <a @click="showUserUpdate = !showUserUpdate">Adresse aktualisieren</a>
            </li>
          </ul>
                </div>
      </v-col>
    </v-row>
    </section>

    </v-col>
    <v-col cols="12" md="4" v-if="baseStore.isDesktop" class="address-sidebar">
      <div v-if="bestellung.bestell_produkt_text != ''" class="address-card address-card--fixed mt-12">
        <p class="eyebrow">Versandadresse</p>
        <h3>Wohin sollen wir Ihre WaizmannTabellen schicken?</h3>
        <ul class="address-list">
          <li>{{ userData.user_name }}</li>
          <li v-if="userData.user_strasse != ''">{{ userData.user_strasse }} {{ userData.user_hsnr }}</li>
          <li v-else><b>Bitte speichern Sie noch Ihre Strasse und Hausnummer</b></li>
          <li v-if="userData.user_ort != ''">{{ userData.user_plz }} {{ userData.user_ort }}</li>
          <li v-else><b>Bitte speichern Sie noch Ihre PLZ und Ort</b></li>
        </ul>

        <div class="address-actions">
          <v-btn variant="text" color="primary" @click="showUserUpdate = !showUserUpdate">
            Adresse aktualisieren
          </v-btn>
          <v-btn color="primary" @click="startNeueBestellung">
            <v-icon start>play_arrow</v-icon>
            Jetzt kostenlos anfordern
          </v-btn>
        </div>
        <p
          class="text-red mt-4"
          v-if="userData && (userData.user_strasse == '' || userData.user_plz == '' || userData.user_ort == '')"
        >
          Bitte speichern Sie noch Ihre Adresse.
        </p>
        <div
          v-if="bestellung.bestell_produkt_text != ''"
          class="selected-products-card mt-4"
        >
          <p class="eyebrow eyebrow--normal mb-1">Ihre gewählten WaizmannTabellen</p>
      
          <div class="selected-products-card__chips">
            <v-chip
              v-for="produkt in getProduktListe()"
              :key="produkt"
              class="selected-chip"
              color="green"
              variant="tonal"
              size="small"
            >
              {{ produkt }}
            </v-chip>
          </div>
        </div>
      </div>

      <template v-if="bestellungen && bestellungen.length > 0 && bestellung.bestell_produkt_text == ''">
        <p class="eyebrow mt-6">Von Ihnen angeforderte</p>
        <h2 class="order-history__title">WaizmannTabellen</h2>
        <div
          v-for="best in bestellungen"
          :key="best.bestell_id"
          class="order-item"
        >
          <div class="order-item__header">
            <span class="order-item__date">{{ best.datumBestellung }}</span>
            <span class="status-chip" :class="best.statusClass">{{ best.status }}</span>
          </div>
          <p class="order-item__title">
            {{ best.bestell_produkt_text || 'WaizmannTabellen' }}
          </p>
          <p v-if="best.bestell_comment" class="order-item__comment">
            {{ best.bestell_comment }}
          </p>
        </div>
      </template>
    </v-col>
  </v-row>
  <v-dialog v-model="showUserUpdate" width="888">
    <v-card>
      <v-card-text >
        <AccountView  />
      </v-card-text>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script setup>
import { inject, ref, onMounted, reactive, computed, watch } from 'vue'
import { storeToRefs } from 'pinia';
import AccountView from '@/components/objects/user/AccountView.vue'
//import WebinarTeaserright from '@/components/sites/objects/webinare/WebinarTeaserright.vue'
  //import { reactive, ref } from "vue";

const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore');
const baseStore = inject('baseStore')
const successStore = inject('successStore');
const errorStore = inject('errorStore');
const userStore = inject('userStore')
const { userData } = storeToRefs(userStore);
const updateDocumentHead = inject('updateDocumentHead');
const showSuccessUpdate = ref(false);
const showUserUpdate = ref(false);

const bestellungen = ref([])
const show_comment = ref(false);
const showFormAdress = ref(false);

const PRODUCT_KEYS = Object.freeze({
  TOGO_ADULT: 'WaizmannTabelle ToGo Erwachsene',
  TOGO_KIDS: 'WaizmannTabelle ToGo Kinder',
  TOGO_PZR: 'WaizmannTabelle ToGo PZR',
  STAND_ADULT_PREMIUM: 'Premium-Aufsteller Erwachsene',
  STAND_ADULT_NORMAL: 'Aufsteller Erwachsene',
  STAND_KIDS_PREMIUM: 'Premium-Aufsteller Kinder',
  STAND_KIDS_NORMAL: 'Aufsteller Kinder',
  STAND_PZR_PREMIUM: 'Premium-Aufsteller PZR',
  STAND_PZR_NORMAL: 'Aufsteller PZR',
  GESAMT: 'WaizmannTabelle Gesamtausgabe',
});

const togoImages = {
  erwachsene: new URL('../../../assets/bestellung/togo_e_picto.png', import.meta.url).href,
  kinder: new URL('../../../assets/bestellung/togo_k_picto.png', import.meta.url).href,
  pzr: new URL('../../../assets/bestellung/togo_pzr_picto.png', import.meta.url).href,
};

const gesamtausgabeImage = new URL('../../../assets/bestellung/gesamtausgabe.png', import.meta.url).href;

const standImages = {
  normal: new URL('../../../assets/bestellung/aufsteller.jpg', import.meta.url).href,
  premium: new URL('../../../assets/bestellung/aufstellerPremium.png', import.meta.url).href,
};

const standVisuals = {
  normal: {
    title: 'Standard-Aufsteller',
    text: 'Kompakter Aufsteller für den Empfang.',
    image: standImages.normal,
  },
  premium: {
    title: 'Premium-Aufsteller',
    text: 'Acrylglas-Aufsteller für den Wartebereich.',
    image: standImages.premium,
  },
};

const standVisualOrder = ['premium', 'normal'];

const togoProducts = [
  {
    id: 'erwachsene',
    title: 'WaizmannTabelle ToGo · Erwachsene',
    description: 'Top 10 Tarife für Erwachsene im praktischen Postkartenformat – perfekt zum Mitnehmen für Ihr Wartezimmer.',
    switchLabel: 'Erwachsenen-Tabelle kostenlos anfordern',
    image: togoImages.erwachsene,
    alt: 'WaizmannTabelle ToGo Erwachsene',
    badge: 'Tipp',
    tableProduct: PRODUCT_KEYS.TOGO_ADULT,
  },
  {
    id: 'kinder',
    title: 'WaizmannTabelle ToGo · Kinder',
    description: 'Die wichtigsten Kindertarife für KFO & Zahnbehandlungen – ideal für Familienberatung in der Praxis.',
    switchLabel: 'Kinder-Tabelle kostenlos anfordern',
    image: togoImages.kinder,
    alt: 'WaizmannTabelle ToGo Kinder',
    tableProduct: PRODUCT_KEYS.TOGO_KIDS,
  },
  {
    id: 'pzr',
    title: 'WaizmannTabelle ToGo · PZR-Flatrate',
    description: 'Top 10 PZR-Flatrate-Tarife: unbegrenzte Leistungen für Prophylaxe plus Zahnersatz & Zahnerhalt.',
    switchLabel: 'PZR-Tabelle kostenlos anfordern',
    image: togoImages.pzr,
    alt: 'WaizmannTabelle ToGo PZR',
    badge: 'Neu',
    tableProduct: PRODUCT_KEYS.TOGO_PZR,
  },
];

const standSelections = reactive({
  erwachsene: { premium: false, normal: false },
  kinder: { premium: false, normal: false },
  pzr: { premium: false, normal: false },
});

const filteredTogoProducts = computed(() => {
  const isKindOnly = Number(userData.value?.user_kind_only) === 1;
  const allowedIds = isKindOnly ? ['kinder', 'pzr'] : ['erwachsene', 'pzr'];
  return togoProducts.filter((product) => allowedIds.includes(product.id));
});

const standProductMap = {
  erwachsene: {
    premium: PRODUCT_KEYS.STAND_ADULT_PREMIUM,
    normal: PRODUCT_KEYS.STAND_ADULT_NORMAL,
  },
  kinder: {
    premium: PRODUCT_KEYS.STAND_KIDS_PREMIUM,
    normal: PRODUCT_KEYS.STAND_KIDS_NORMAL,
  },
  pzr: {
    premium: PRODUCT_KEYS.STAND_PZR_PREMIUM,
    normal: PRODUCT_KEYS.STAND_PZR_NORMAL,
  },
};

const bestellung = reactive({
    bestell_status: 0,
    bestell_comment: "",
    bestell_produkt_text: "",
    bestell_kategorie: 0,
    action: 'neueBestellung',

  });

function getProduktListe() {
  if (!bestellung.bestell_produkt_text) {
    return [];
  }
  return bestellung.bestell_produkt_text
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item !== '');
}

function updateProduktListe(list) {
  bestellung.bestell_produkt_text = list.length ? list.join(', ') : '';
}

function isProductSelected(product) {
  return getProduktListe().includes(product);
}

function addProduktName(product, was = 'tabelle') {
  if (was === 'webinar') {
    bestellung.bestell_kategorie = 1;
  } else if (was === 'tabelle') {
    bestellung.bestell_kategorie = 0;
  }
  const produkte = getProduktListe();
  if (!produkte.includes(product)) {
    produkte.push(product);
    updateProduktListe(produkte);
  }
}

function removeProduktName(product) {
  const produkte = getProduktListe().filter((item) => item !== product);
  updateProduktListe(produkte);
}

function toggleProduct(product, was = 'tabelle') {
  if (isProductSelected(product)) {
    removeProduktName(product);
  } else {
    addProduktName(product, was);
  }
}

function setStandSelection(productId, option, active) {
  const mapping = standProductMap[productId];
  if (!mapping || !mapping[option]) {
    return;
  }

  standSelections[productId][option] = active;

  if (active) {
    addProduktName(mapping[option], 'tabelle');
  } else {
    removeProduktName(mapping[option]);
  }
}

function clearStandSelections(productId) {
  const mapping = standProductMap[productId];
  if (!mapping) {
    return;
  }
  Object.keys(mapping).forEach((option) => {
    setStandSelection(productId, option, false);
  });
}

function handleStandClick(productId, option) {
  const product = togoProducts.find((item) => item.id === productId);
  if (!product || !isProductSelected(product.tableProduct)) {
    return;
  }
  const nextState = !standSelections[productId][option];
  setStandSelection(productId, option, nextState);
}

function toggleTogoSelection(product) {
  toggleProduct(product.tableProduct, 'tabelle');
  if (!isProductSelected(product.tableProduct)) {
    clearStandSelections(product.id);
  }
}

function toggleGesamtausgabe() {
  addOderEntferneProdukt(PRODUCT_KEYS.GESAMT, 'tabelle');
}

function hasStandSelection(productId) {
  const selection = standSelections[productId];
  return !!selection && (selection.premium || selection.normal);
}

function needsStandSelection(productId, productKey) {
  return isProductSelected(productKey) && !hasStandSelection(productId);
}

function resetSelections() {
  bestellung.bestell_produkt_text = '';
  Object.keys(standSelections).forEach((key) => {
    clearStandSelections(key);
  });
}

watch(
  () => Number(userData.value?.user_kind_only),
  (kindOnly) => {
    const allowed = kindOnly === 1 ? ['kinder', 'pzr'] : ['erwachsene', 'pzr'];
    togoProducts.forEach((product) => {
      if (!allowed.includes(product.id)) {
        if (isProductSelected(product.tableProduct)) {
          removeProduktName(product.tableProduct);
        }
        clearStandSelections(product.id);
      }
    });
  },
  { immediate: true }
);


async function startNeueBestellung()
{
  loaderStore.setLoader(true)
  const response = await baseCalls.bestellungPost(bestellung)
  if (response.data.success) {
    showSuccessUpdate.value = true;
    loaderStore.setLoader(false)
    successStore.setSuccess(true,'Ihre Bestellung wurde erfolgreich gespeichert','Ihre Bestellung wird in Kürze bearbeitet.')
    resetSelections();
    bestellung.bestell_comment = '';
    getBestellungen();
  } else {
    loaderStore.setLoader(false)
    errorStore.setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.')
  }
}
async function getBestellungen() {
  console.log('getBestellungen')

  const response = await baseCalls.bestellungGet({ action: 'getalluserbestellungen', id: 0 })
  if (response.data.success) {
    console.log('getBestellungen success')
    bestellungen.value = response.data.bestellungen
  }
 
}

function addOderEntferneProdukt(titel, was) {
  toggleProduct(titel, was);
}


onMounted(() => {
  if (userData.value) {
  getBestellungen()
  }
  setTimeout(() => {
    userStore.setLoginView(false)
  }, 1000);

  updateDocumentHead(
    "WaizmannTabellen anfordern | kostenlos",
    "Jetzt WaizmannTabellen anfordern - kostenlos - für Zahnärzte"
  );
})
</script>

<style scoped>
.mb-4 {
  margin-bottom: 16px;
}

.text-right {
  text-align: right;
}

.togo-section {
  background-color: #f7f9fc;
  border-radius: 8px;
  padding: 24px 24px 8px;
}

.togo-section__title {
  font-size: 1.35rem;
  margin-bottom: 4px;
}

.togo-section__subtitle {
  color: #5a6a85;
  margin-bottom: 16px;
}

.togo-row {
  background: #fff;
  border: 1px solid #e1e6ef;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 960px) {
  .togo-row {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.togo-row__info {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.togo-row__picto {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.togo-row__title {
  color: #3166a5;
  margin-bottom: 4px;
}

.togo-row__text {
  margin: 0;
  color: #4a5568;
  line-height: 1.35;
}

.togo-row__stands {
  min-width: 220px;
}

.stands-label {
  font-weight: 600;
  margin-bottom: 8px;
  color: #1f3a63;
}

.stand-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.stand-btn {
  border-radius: 999px;
  text-transform: none;
}

.stand-btn--active {
  background-color: #3166a5 !important;
  color: #fff !important;
}

.stand-hint {
  display: block;
  margin-top: 8px;
  font-size: 0.75rem;
  color: #6b7a99;
}

.stand-visuals {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.stand-visuals__item {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border: 1px dashed #d5ddeb;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  cursor: pointer;
  flex: 1 1 240px;
}

.stand-visuals__item--disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.stand-visuals__item--active {
  border-color: #2e7d32;
  box-shadow: 0 6px 18px rgba(46, 125, 50, 0.15);
}

.stand-visuals__image {
  width: 72px;
  height: 72px;
  object-fit: contain;
}

.stand-visuals__title {
  margin: 0;
  font-weight: 600;
  color: #1f3a63;
}

.stand-visuals__text {
  margin: 2px 0 0;
  color: #4a5568;
  font-size: 0.85rem;
}

.stand-visuals__content {
  flex: 1;
}

.edition-row {
  background: #fff;
  border: 1px solid #e1e6ef;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.edition-row__info {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-direction: column;
}

.edition-row__image {
  width: 120px;
  height: auto;
  object-fit: contain;
}

.edition-row__title {
  color: #3166a5;
  margin-bottom: 4px;
}

.edition-row__text {
  margin: 0;
  color: #4a5568;
}

.edition-row__content {
  flex: 1;
}

@media (min-width: 960px) {
  .edition-row__info {
    flex-direction: row;
    align-items: center;
  }
}

.address-card {
  background: #fff;
  border: 1px solid #e1e6ef;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 10px 30px rgba(20, 45, 90, 0.05);
}

.address-sidebar {
  position: relative;
  min-height: 600px;
}

.address-card--fixed {
  position: fixed;
  top: 100px;
  right: clamp(16px, 5vw, 96px);
  width: min(360px, calc(100vw - 64px));
  z-index: 5;
}

.address-card__default {
  font-size: 0.9rem;
  color: #4a5568;
  line-height: 1.4;
}

.address-request-card,
.address-check-card {
  text-align: left;
  background-color: #f2f2f2;
  border-radius: 8px;
}

.hint-alert {
  font-size: 1rem;
  line-height: 1.4;
}

.product-selection {
  cursor: pointer;
}

.product-selection:focus-visible {
  outline: 2px solid #3166a5;
  outline-offset: 4px;
  border-radius: 8px;
}

.selected-products-card {
  background: #fff;
  border: 1px solid #e1e6ef;
  border-radius: 8px;
  padding: 16px;
}

.selected-products-card__hint {
  margin: 0 0 12px;
  color: #4a5568;
  font-size: 0.9rem;
}

.selected-products-card__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.selected-chip {
  border-radius: 6px;
  text-transform: none;
  font-weight: 600;
}

.eyebrow {
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  color: #6b7a99;
  margin-bottom: 4px;
}
.eyebrow--normal {
  text-transform: none;
  letter-spacing: normal;
  font-size: 0.9rem;
}

.address-list {
  list-style: none;
  padding: 0;
  margin: 12px 0 16px;
  color: #1f3a63;
}

.address-list li + li {
  margin-top: 4px;
}

.address-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.order-history__title {
  margin: 0 0 16px;
}

.order-item {
  border: 1px solid #e6ebf5;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #fdfefe;
}

.order-item__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 0.85rem;
}

.order-item__title {
  font-weight: 600;
  margin: 0 0 4px;
}

.order-item__comment {
  margin: 0;
  color: #4a5568;
  font-size: 0.9rem;
}

.status-chip {
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 0.75rem;
  text-transform: uppercase;
}
</style>

<div style="position: fixed; top: 50%; left: 0; right: 0; transform: translateY(-50%); z-index: 1000;">
  <!-- Dein Inhalt -->
</div>
